const alignMap = {
    left: "flex-start",
    center: "center",
    right: "flex-end",
};

export default alignMap;
